/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chunky_Sharp_Elk_FryInputs */

const es_chunky_sharp_elk_fry = /** @type {(inputs: Chunky_Sharp_Elk_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velero`)
};

const gl_chunky_sharp_elk_fry = /** @type {(inputs: Chunky_Sharp_Elk_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veleiro`)
};

const en_chunky_sharp_elk_fry = /** @type {(inputs: Chunky_Sharp_Elk_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailboat`)
};

/**
* | output |
* | --- |
* | "Sailboat" |
*
* @param {Chunky_Sharp_Elk_FryInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const chunky_sharp_elk_fry = /** @type {((inputs?: Chunky_Sharp_Elk_FryInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chunky_Sharp_Elk_FryInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_chunky_sharp_elk_fry(inputs)
	if (locale === "en") return en_chunky_sharp_elk_fry(inputs)
	return es_chunky_sharp_elk_fry(inputs)
});